import { Category } from '@/types/Category';
import BaseModel from './BaseModel';
import { CATEGORY_ROOT } from '@/helpers/BuilderHelper';

class CategoryModel extends BaseModel<Category> {
    constructor() {
        super({ modelName: 'category' });
    }

    getSlug = (categoryName: string) => {
        return categoryName
            .trim()
            .toLowerCase()
            .replace(/[^A-z]/g, '-')
            .trimEnd();
    };

    getFromName = async (name: string) => {
        const slug = this.getSlug(name);

        const allPossibleCategories = (await this.findAll({ filters: { limit: 100 } })).map(this.fromBuilderContent);

        for (const category of allPossibleCategories) {
            if (`${CATEGORY_ROOT}${slug}` === category.categoryUrl) {
                // TODO refactor check to come from a generic place
                return category;
            }
        }

        return null;
    };

    fromBuilderContent = (object: any) => {
        if (!object) {
            return {
                id: '',
                name: '',
                longName: null,

                description: '',
                categoryUrl: '',
                isSeries: false,
                image: '',
                lastUpdated: '',
                exclusiveForLocales: [],
            };
        }

        let name;
        let category = object;

        if (object.data === undefined) {
            name = object.name ?? '';
        } else {
            category = object.data;
            name = object.name ?? object.data.name;
        }

        const categorySlug = this.getSlug(name);

        // TODO generalize this parser here
        return {
            id: object.id,
            name,
            longName: category.longName ?? null,

            categoryUrl: (CATEGORY_ROOT + categorySlug).replace(/\/{2,}/g, '/'),

            isSeries: !!category.isSeries || false,
            categorySlug,
            description: category.description || '',
            image: category.image || '',
            lastUpdated: object.lastUpdated || '',
            exclusiveForLocales: category.exclusiveForLocales ?? [],
        };
    };
}

export default new CategoryModel();
